import { useEffect, useState } from 'react';
import { publicApi } from '../lib/publicApi';

export function useProductCategories() {
  const [categories, setCategories] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await publicApi.get('/product-categories');
        if (!cancelled) {
          setCategories(res.data.categories || []);
          setError(false);
        }
      } catch {
        if (!cancelled) {
          setCategories([]);
          setError(true);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    categories: categories ?? [],
    loading: categories === null,
    error,
  };
}
